module.exports = __webpack_public_path__ + "img/bootstrap4-dark-blue.8b662aa6.svg";